function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape Copy 4");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape-Copy-4",
  fill: "#FAAD14",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.5,0 C2.90976562,0 0,2.90976562 0,6.5 C0,10.0902344 2.90976562,13 6.5,13 C10.0902344,13 13,10.0902344 13,6.5 C13,2.90976563 10.0902344,0 6.5,0 Z M9.80458984,4.52460937 L5.240625,9.10380859 C5.23935547,9.10507813 5.23681641,9.10761719 5.23554687,9.10888672 C5.20507812,9.14189453 5.16826172,9.17109375 5.12763672,9.19394531 C5.05654297,9.23457031 4.97783203,9.25361328 4.90166016,9.25361328 C4.74296875,9.25361328 4.58808594,9.17109375 4.50429687,9.02255859 L3.12177734,6.60537109 C2.99609375,6.38574219 3.07226562,6.10644531 3.29189453,5.98203125 C3.51152344,5.85634766 3.79082031,5.93251953 3.91523437,6.15214844 L4.99941406,8.05009766 L9.15712891,3.8796875 C9.33486328,3.70068359 9.62431641,3.70068359 9.80332031,3.87841797 C9.98232422,4.05742187 9.98232422,4.346875 9.80458984,4.52460937 Z",
  id: "Shape-Copy"
})));

var SvgCheckWithYellowCircle = function SvgCheckWithYellowCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckWithYellowCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-with-yellow-circle.077a387b.svg";
export { ForwardRef as ReactComponent };